import { EDisbursementMethod } from "../../workers-shared/EDisbursementMethod";
import { zSchema } from "../../schema-validation";
import { EClassification } from "../EClassification";

// @TODO(todd): Add more to this as needed.
export const companySchema = zSchema.object({
  business_name: zSchema.string().optional(),
  classification: zSchema.nativeEnum(EClassification),
  email: zSchema.string(),
  fallback_disbursement_method: zSchema
    .nativeEnum(EDisbursementMethod)
    .optional(),
  use_i9_admin_review: zSchema.boolean().optional(),
  use_skippable_bank_info: zSchema.boolean().optional(),
});
